import { Timer } from "lucide-react";
import { TeamLogo } from "./TeamBits";
import { hotColor } from "./ProbabilityWidget";

const HT_LABEL = { HT1: "1T · 1", HTX: "1T · X", HT2: "1T · 2", "HTO0.5": "1T Over 0.5", "HTO1.5": "1T Over 1.5", "HTU1.5": "1T Under 1.5", HTGG: "1T Goal", HTNG: "1T No Goal" };

function Cell({ label, value, testId }) {
  return (
    <div className="border border-[#27272A] p-2.5" data-testid={testId}>
      <div className="label text-[9px]">{label}</div>
      <div className="mono font-black text-lg" style={{ color: hotColor(value) }}>{value}%</div>
    </div>
  );
}

function TeamHalf({ team, fh, side }) {
  return (
    <div className="space-y-3" data-testid={`ht-team-${side}`}>
      <div className="flex items-center gap-3">
        <TeamLogo team={team} size={24} />
        <div className="heading text-lg font-black truncate">{team.name}</div>
        <span className="label text-[9px] ml-auto">{fh.sample} gare</span>
      </div>
      <div className="flex gap-2 mono text-sm font-black" data-testid={`ht-record-${side}`}>
        <span className="px-2 py-1 bg-[#39FF14] text-black">V {fh.won}</span>
        <span className="px-2 py-1 bg-[#FFCC00] text-black">N {fh.drawn}</span>
        <span className="px-2 py-1 bg-[#FF3B30] text-black">P {fh.lost}</span>
        <span className="ml-auto text-[11px] text-[#A1A1AA] self-center">gol 1T: {fh.goals_for_avg} fatti · {fh.goals_against_avg} subiti</span>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
        <Cell label="Over 0.5" value={fh.over_0_5} testId={`ht-o05-${side}`} />
        <Cell label="Over 1.5" value={fh.over_1_5} testId={`ht-o15-${side}`} />
        <Cell label="Under 1.5" value={fh.under_1_5} testId={`ht-u15-${side}`} />
        <Cell label="Goal" value={fh.btts} testId={`ht-gg-${side}`} />
        <Cell label="No Goal" value={100 - fh.btts} testId={`ht-ng-${side}`} />
      </div>
    </div>
  );
}

export function FirstHalfStats({ match, model }) {
  const cs = match.corner_stats;
  const h = cs?.home?.first_half;
  const a = cs?.away?.first_half;
  if (!h && !a) return null;
  return (
    <div className="surface-raised p-6 space-y-6" data-testid="first-half-stats">
      <div className="label flex items-center gap-2"><Timer size={12} strokeWidth={1.5} /> Primo tempo · ultime 10 partite</div>
      {h && <TeamHalf team={match.home} fh={h} side="home" />}
      {a && <TeamHalf team={match.away} fh={a} side="away" />}
      {model?.first_half?.length > 0 && (
        <div>
          <div className="label text-[10px] mb-2">Probabilità modello primo tempo</div>
          <div className="divide-y divide-[#27272A]">
            {model.first_half.map((r) => (
              <div key={r.code} className="py-2 flex items-start gap-3" data-testid={`ht-model-${r.code}`}>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-bold">{HT_LABEL[r.code] || r.code}</div>
                  <div className="text-[10px] mono text-[#71717A] leading-snug">{r.evidence}</div>
                </div>
                <div className="mono font-black" style={{ color: hotColor(r.model) }}>{r.model}%</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
